// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__27XPG","legacyBtn":"MutateMid_legacyBtn__2KfZW"};